import { endpoints, request } from '!core/api';

export const onboardingServices = {
  getBankInfo: () => request.get(endpoints.backoffice('wsbGetBankInfo')),
  getClassifDescriptions: ({ classifierId }) =>
    request.get(
      endpoints.backoffice(
        `wsbGetClassifDescriptions${
          classifierId ? `?types=${classifierId}` : ''
        }`,
      ),
    ),
  getNewAccountRequest: ({
    taxId,
    bankCode,
    ibanCode,
    bankAccountNumber,
    dataAccessAgreement,
    documentCode,
    docNumber,
    email,
    ibanCode2,
    legalStatus,
    hasInitialOtpValidation,
  }) =>
    request.postFormUrlEncoded(
      endpoints[hasInitialOtpValidation ? 'chnn' : 'backoffice'](
        'wsbNewAccountRequest',
      ),
      {
        taxId,
        bankCode,
        ibanCode,
        bankAccountNumber,
        gdprAcceptance: dataAccessAgreement === 'Y' ? 'S' : null,
        documentCode,
        docNumber,
        email,
        ibanCode2,
        currencyIbanCode2: ibanCode2 ? 'USD' : null,
        legalStatus: legalStatus ?? null,
      },
    ),
  getNewAccountInfo: ({ openingRequestId }) =>
    request.get(
      endpoints.backoffice(
        `wsbGetNewAccountInfo?openingRequestId=${openingRequestId}`,
      ),
    ),
  getDocumentsList: ({ openingRequestId }) =>
    request.get(
      endpoints.backoffice(
        `wsbGetDocumentsList?openingRequestId=${openingRequestId}`,
      ),
    ),
  uploadNoteAttach: ({ file, description, fileKey }) =>
    request.uploadFile(
      endpoints.frameworkbo(`uploadNoteAttach?description=${description}`),
      file,
      fileKey,
    ),
  submitFinancialContract: ({ openingRequestId, formValues }) =>
    request.post(
      endpoints.backoffice(
        `wsbFinancialContractHandler?openingRequestId=${openingRequestId}`,
      ),
      {
        contractDetails: formValues,
      },
    ),
  generateContractPdf: ({ openingRequestId }) =>
    request.get(
      endpoints.backoffice(
        `wsbPDFGeneration?openingRequestId=${openingRequestId}`,
      ),
    ),
  submitDocument: ({
    openingRequestId,
    documentCode,
    deleteDoc,
    lifetime,
    expirationDate,
    docNumber,
    noteId,
  }) =>
    request.post(
      endpoints.backoffice(
        `wsbStoreDocuments?openingRequestId=${openingRequestId}&documentCode=${documentCode}&deleteDoc=${deleteDoc}&isLifetime=${lifetime}&${
          lifetime === 'S'
            ? `docNumber=${docNumber}&noteId=${noteId}`
            : `expirationDate=${expirationDate}&docNumber=${docNumber}&noteId=${noteId}`
        }`,
      ),
    ),
  setOnboardingState: ({ openingRequestId, state, validationCode }) =>
    request.post(
      endpoints.chnn(
        `wsbSetOnboardingState?onboardingId=${openingRequestId}&state=${state}${
          validationCode ? `&otp=${validationCode}` : ''
        }`,
      ),
    ),
  getLegalStatusList: () =>
    request.get(endpoints.backoffice('wsbGetLegalStatusList')),
  getInitialDocumentsList: ({ legalStatus }) =>
    request.get(
      endpoints.backoffice(
        `WsbGetInitialDocumentsList?legalStatus=${legalStatus}`,
      ),
    ),
};
